import React, { FC } from "react";
import _ from "lodash";
import { ApplicationFeature } from "@green0meter/api-client";
import { useTranslation } from "react-i18next";

import { CO2_CONFIG, CSRD_CONFIG } from "@pages";
import { useGetCurrentCompanyInfo } from "@api";
import { CircularProgress, Grid } from "@components/base";
import { useUserStore } from "@store/user";
import Overview from "@components/main/co2/hub/Overview";
import { ESRS_REPORT_ID } from "@constants";

interface Overviews {}

const Overviews: FC<Overviews> = () => {
  const { user } = useUserStore();
  const { t } = useTranslation();
  const { currentCompanyInfo, isLoadingCurrentCompanyInfo } =
    useGetCurrentCompanyInfo(user);

  if (isLoadingCurrentCompanyInfo || !currentCompanyInfo) {
    return <CircularProgress />;
  }

  if (_.isEmpty(currentCompanyInfo.companyFeatureFunctionalities)) {
    return (
      <Grid container spacing={3}>
        <Grid size={12}>
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }

  const featureComponents: Partial<Record<ApplicationFeature, JSX.Element>> = {
    [ApplicationFeature.CO2]: (
      <Overview
        key="co2"
        title={t(CO2_CONFIG.overview.titleKey)}
        dashboardPath={CO2_CONFIG.overview.dashboardPath}
        viewDashboardText={t(CO2_CONFIG.overview.viewDashboardTextKey)}
        reportPageId={CO2_CONFIG.overview.reportPageId}
      />
    ),
    [ApplicationFeature.CSRD]: (
      <Overview
        key="csrd"
        title={t(CSRD_CONFIG.overview.titleKey)}
        dashboardPath={CSRD_CONFIG.overview.dashboardPath}
        viewDashboardText={t(CSRD_CONFIG.overview.viewDashboardTextKey)}
        reportPageId={CSRD_CONFIG.overview.reportPageId}
        reportId={ESRS_REPORT_ID}
      />
    ),
    // [ApplicationFeature.SFDR]: <Overview key="sfdr" />,
  };

  const enabledOverviews = currentCompanyInfo.companyFeatureFunctionalities
    ?.map(
      (feature) =>
        featureComponents[feature.applicationFeature as ApplicationFeature],
    )
    .filter((overview): overview is JSX.Element => Boolean(overview));

  return (
    <Grid container spacing={3}>
      {enabledOverviews.map((overview, index) => (
        <Grid size={12} key={overview.key ?? index}>
          {overview}
        </Grid>
      ))}
    </Grid>
  );
};

export default Overviews;
